document.addEventListener("DOMContentLoaded", function() {
      var carousel = document.querySelector('.fv-sp-carousel');
      if (!carousel) return;
      var inner = carousel.querySelector('.fv-sp-carousel-inner');
      var slides = carousel.querySelectorAll('.fv-sp-slide');
      var current = 0;
      var total = slides.length;
      function setup() {
          var w = carousel.offsetWidth;
          slides.forEach(function(s) { s.style.width = w + 'px'; });
      }
      setup();
      function goTo(index) {
          current = (index + total) % total;
          inner.style.transform = 'translateX(-' + (current * carousel.offsetWidth) + 'px)';
      }
      carousel.querySelector('.fv-sp-btn-prev').addEventListener('click', function(e) {
          e.preventDefault(); goTo(current - 1);
      });
      carousel.querySelector('.fv-sp-btn-next').addEventListener('click', function(e) {
          e.preventDefault(); goTo(current + 1);
      });
  });


document.addEventListener("DOMContentLoaded", function () {
	const fvswiper = new Swiper(".fv-swiper", {
		autoHeight: true,
		loop: true,
		speed: 500,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 4800, // 任意で調整
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: ".custom-swiper-button-next",
			prevEl: ".custom-swiper-button-prev",
		},
		// pagination を progressbar に設定（これを1つだけ使う）
		pagination: {
			el: ".swiper-pagination-progressbar",
			type: "progressbar",
		},
		on: {
			init: function () {
				updateFraction(this);
			},
			slideChange: function () {
				updateFraction(this);
			},
		},
	});
});

function updateFraction(swiperInstance) {
	// loop が true の場合、duplicated なスライドが入るのでそれを除外して数える
	const slides = swiperInstance.el.querySelectorAll(
		".fv-swiper .swiper-slide:not(.swiper-slide-duplicate)"
	);
	const total = slides.length;
	// loop でも realIndex を使えば「本来のインデックス」を取得できる
	const current =
		typeof swiperInstance.realIndex === "number"
			? swiperInstance.realIndex + 1
			: swiperInstance.activeIndex + 1;
	const el = swiperInstance.el.querySelector(".swiper-pagination-fraction");
	if (el) el.textContent = `${current} / ${total}`;
}

document.addEventListener("DOMContentLoaded", function () {
	// 動画用のスライダー
	var swiper = new Swiper(".hero-swiper", {
		slidesPerView: 1.4,
		centeredSlides: true,
		loop: true,
		spaceBetween: 20,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + (index + 1) + "</span>";
			},
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 1.6,
				spaceBetween: 12,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 2.8,
				spaceBetween: 20,
			},
			1500: {
				slidesPerView: 3.4,
				spaceBetween: 20,
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},
		on: {
			init: function () {
				controlHeroVideos(this);
			},
			slideChangeTransitionEnd: function () {
				controlHeroVideos(this);
			},
		},
	});
});

//中央のスライダーを再生する関数
function controlHeroVideos(swiperInstance) {
	const slides = swiperInstance.slides;

	slides.forEach((slide) => {
		const video = slide.querySelector(".hero-product-video video");
		if (!video) return;

		if (slide.classList.contains("swiper-slide-active")) {
			// 中央スライドの動画を最初から再生
			video.currentTime = 0;
			video.play().catch(() => {
				// 自動再生ブロック対策
			});
		} else {
			// その他の動画は停止して巻き戻す
			video.pause();
			video.currentTime = 0;
		}
	});
}

// カードの高さを統一する関数
function equalizeCardHeights() {
	const cards = document.querySelectorAll(".new-items-card");
	let maxHeight = 0;

	// 一度高さをリセット
	cards.forEach((card) => {
		card.style.height = "auto";
	});

	// 最大の高さを取得
	cards.forEach((card) => {
		const cardHeight = card.offsetHeight;
		if (cardHeight > maxHeight) {
			maxHeight = cardHeight;
		}
	});

	// 全てのカードの高さを最大値に統一
	cards.forEach((card) => {
		card.style.height = maxHeight + "px";
	});
}

document.addEventListener("DOMContentLoaded", () => {
	// 新着アイテムのスライダー
	const swiper = new Swiper(".new-items-swiper", {
		slidesPerView: 4,
		slidesPerGroup: 1,
		spaceBetween: 20,
		speed: 500,
		loop: true,

		navigation: {
			nextEl: ".new-items-container .swiper-button-next",
			prevEl: ".new-items-container .swiper-button-prev",
		},

		pagination: {
			el: ".new-items-container .swiper-pagination",
			clickable: true,
			type: "bullets",
		},

		breakpoints: {
			320: {
				slidesPerView: 1.5,
				spaceBetween: 15,
				centeredSlides: true,
			},
			480: {
				slidesPerView: 2,
				spaceBetween: 15,
				centeredSlides: true,
			},
			550: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 18,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},

		on: {
			init: function () {
				setTimeout(() => {
					equalizeCardHeights();
				}, 100);
			},
			resize: function () {
				setTimeout(() => {
					equalizeCardHeights();
				}, 100);
			},
		},
	});

	// 画像読み込み完了後に高さを再調整
	window.addEventListener("load", () => {
		setTimeout(() => {
			equalizeCardHeights();
		}, 200);
	});

	// ウィンドウサイズ変更時に高さを再調整
	window.addEventListener("resize", () => {
		setTimeout(() => {
			equalizeCardHeights();
		}, 100);
	});

	// カートボタンのクリックイベント（新着）
	document.querySelectorAll(".new-items-button-cart").forEach((button) => {
		button.addEventListener("click", function () {
			const productName = this.closest(".new-items-card").querySelector(
				".new-items-card-name"
			).textContent;
		});
	});

	// カートボタンのクリックイベント（全商品）
	document.querySelectorAll(".all-items-button-cart").forEach((button) => {
		button.addEventListener("click", function () {
			const productName = this.closest(".all-items-card").querySelector(
				".all-items-card-title"
			).textContent;
		});
	});

	// SPメニューの閉じるボタンのクリックイベント
	const spMenu = document.querySelector(".sp-menu");
	const spMenuClose = document.querySelector(".sp-menu-close");
	const spMenuHamburger = document.querySelector(".menu-hamburger");

	if (spMenuClose) {
		spMenuClose.addEventListener("click", function () {
			spMenu?.classList.remove("active");
		});
	}

	// SPメニューの開くボタン（ハンバーガーメニュー）のクリックイベント
	if (spMenuHamburger) {
		spMenuHamburger.addEventListener("click", function () {
			spMenu?.classList.add("active");
		});
	}

	// SPメニュー内のリンクをクリックしたときにメニューを閉じる
	const spMenuLinks = document.querySelectorAll(".sp-menu a");
	for (const link of spMenuLinks) {
		link.addEventListener("click", function () {
			spMenu?.classList.remove("active");
		});
	}
});

// document.addEventListener("DOMContentLoaded", () => {
// 	const subjectSwiper = new Swiper(".subject-item-swiper", {
// 		loop: true, // ループさせたい場合
// 		rewind: true,
// 		centeredSlides: true,
// 		slidesPerView: 1.7,
// 		// slidesPerGroup: 1,
// 		// loopAdditionalSlides: 2,
// 		// loopedSlides: 2,
// 		spaceBetween: 20, // スライド間の余白(px)
// 		pagination: {
// 			el: ".subject-item-swiper .swiper-pagination",
// 			clickable: true,
// 		},
// 		navigation: {
// 			nextEl: ".subject-item-swiper .swiper-button-next",
// 			prevEl: ".subject-item-swiper .swiper-button-prev",
// 		},
// 	});
// });

//document.addEventListener("DOMContentLoaded", () => {
//  document.querySelectorAll(".subject-item-swiper").forEach((el) => {
//   // すでに初期化済みならスキップ（セクション再描画対策）
//    if (el.swiper) return;

    //new Swiper(el, {
//     loop: true,
//      rewind: true, // loop と同時は基本不要だが、既存維持なら残してOK
//      centeredSlides: true,
//      slidesPerView: 1.3,
//     spaceBetween: 8,
//      pagination: {
//        el: el.querySelector(".swiper-pagination"),
//       clickable: true,
//     },
//     navigation: {
//       nextEl: el.querySelector(".swiper-button-next"),
//        prevEl: el.querySelector(".swiper-button-prev"),
//      },
//   });
// });
//});

 document.addEventListener("DOMContentLoaded", function() {
      var carousel = document.querySelector('.fv-sp-carousel');
      if (!carousel) return;
      var inner = carousel.querySelector('.fv-sp-carousel-inner');
      var total = carousel.querySelectorAll('.fv-sp-slide').length;
      var current = 0;

      function goTo(index) {
          current = (index + total) % total;
          inner.style.transform = 'translateX(-' + (current * 100) + '%)';
      }

      carousel.querySelector('.fv-sp-btn-prev').addEventListener('click', function(e) {
          e.preventDefault(); goTo(current - 1);
      });
      carousel.querySelector('.fv-sp-btn-next').addEventListener('click', function(e) {
          e.preventDefault(); goTo(current + 1);
      });

      var startX = 0;
      carousel.addEventListener('touchstart', function(e) {
          startX = e.touches[0].clientX;
      }, {passive: true});
      carousel.addEventListener('touchend', function(e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
              if (diff > 0) goTo(current + 1);
              else goTo(current - 1);
          }
      }, {passive: true});
  });

  // FVメイン画像 スライダー（3枚・ペッキング表示・5秒ごと自動スライド）
  // FVメイン画像 スライダー（3枚・ペッキング表示・5秒ごと自動スライド・無限ループ）
document.addEventListener("DOMContentLoaded", function () {
    var fvMainEl = document.querySelector('.fv-main-swiper');
    if (!fvMainEl) return;

    // Swiper v11のloopは最低「2×slidesPerView+1」枚必要。3枚だと足りないので6枚に複製
    var wrapper = fvMainEl.querySelector('.swiper-wrapper');
    var originalSlides = wrapper.querySelectorAll('.swiper-slide');
   
    originalSlides.forEach(function (slide) {
        wrapper.appendChild(slide.cloneNode(true));
    });

      var fvMainSwiper = new Swiper('.fv-main-swiper', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 8,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.fv-main-pagination',
            clickable: true,

			 
            
         },
    });
		 
    // 6個生成されるbulletを「3個だけ表示・realIndex%3でactive」に制御
    function updateFvMainBullets() {
        var bullets = document.querySelectorAll('.fv-main-pagination .swiper-pagination-bullet');
        if (bullets.length === 0) return;
        var displayIdx = fvMainSwiper.realIndex % 3;
        for (var i = 0; i < bullets.length; i++) {
            if (i >= 3) {
                bullets[i].style.display = 'none';
            }
            bullets[i].classList.remove('swiper-pagination-bullet-active');
        }
        if (bullets[displayIdx]) {
            bullets[displayIdx].classList.add('swiper-pagination-bullet-active');
        }
    }

    // 初期化完了後に1回実行（DOM生成待ちで100ms遅延）
    setTimeout(updateFvMainBullets, 100);

    // スライド変更時にも実行
    fvMainSwiper.on('slideChange', function () {
        setTimeout(updateFvMainBullets, 0);
    });

    });

